import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import SocialLinkPage from './SocialLinkPage';
import {
    logInUser as logInUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    clearAuthNotification as clearAuthNotificationAction,
} from '../../actions/auth';
import { sendResetPasswordEmail as sendResetPasswordEmailAction } from '../../actions/forgotPassword';

const _mapStateToProps = ({ authentication, social }) => ({
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
    email: authentication.email,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    socialData: social.socialData,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    onLogInUser: logInUserAction,
    moveBack: moveBackAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SocialLinkPage),
);
